export default __webpack_public_path__ + "static/media/noimage.ca2ab394.svg";